<template>
  <Loading v-if="loading" />
  <DialogBox v-else :title="is_pt_br ?  'Excluir bloco' : 'Delete block'" @close="$emit('close')">
    <template>
      <legend>
        {{is_pt_br ?
        `Deseja excluir os registro (incluindo fotos e videos) do bloco ${ name } ?`
        : `Do you want to delete records (including photos and videos) from the block ${name}`
        }}
      </legend>
    </template>
    <template v-slot:footer>
      <button
        @click.prevent="handleDeleteStone"
        class="w-100 mt-1 btn btn-outline-danger"
      >
        {{is_pt_br ?  "Excluir" : "Delete"}}
      </button>
    </template>
  </DialogBox>
</template>

<script>
import DialogBox from "../utils/DialogBox.vue";
import Loading from "../utils/AnimateLoad.vue";
import { mapActions } from "vuex";
export default {
  name: "DeleteStone",
  props: { stone_id: Number, name: String },
  data() {
    return {
      loading: false,
    };
  },
  components: { DialogBox, Loading },
  computed: {
    is_pt_br() {
      return this.$store.getters.is_pt_br;
    },
  },
  methods: {
    ...mapActions("stone", ["deleteStone"]),
    ...mapActions("alertes", ["alertSuccess", "alertDanger"]),

    async handleDeleteStone() {
      this.loading = true;
      await this.deleteStone(this.stone_id).then((res) => {
        this.$emit('close', null)
        this.$emit('deleted')
        console.log("Bloco excluído com sucesso", res);
      })
      .catch(error => {
        console.log(error)
        this.$emit('close', error)
        this.alertDanger(`Erro ao excluír bloco: ${error}`)
        });
      this.loading = false;
    },
  },
};
</script>
